<template>
    <div>
        <el-tabs v-model="cur" @tab-click="handleClick">
            <el-tab-pane label="全部订单" name="0"></el-tab-pane>
            <el-tab-pane label="待付款" name="10"></el-tab-pane>
            <el-tab-pane label="待发货" name="20"></el-tab-pane>
            <el-tab-pane label="待收货" name="30"></el-tab-pane>
            <el-tab-pane label="已完成" name="40"></el-tab-pane>
        </el-tabs>
        <div class="ordersContent" v-if="list.length > 0">
            <div class="orderTitles flx alc" v-if="list.length > 0">
                <div class="orderTitle1">
                    订单详情
                </div>
                <div class="orderTitle2">
                    金额
                </div>
                <div class="orderTitle3">
                    订单状态
                </div>
                <div class="orderTitle4">
                    操作
                </div>
            </div>
            <div class="orderItems">
                <div class="orderItem" v-for="item,index in list">
                    <div class="orderTit flx alc">
                        <div v-text="item.createtime" style="margin-right: 24px;"></div>
                        <div v-text="`订单号:${item.order_no}`"></div>
                    </div>
                    <div class="orderContent flx">
                        <div class="orderc1 flx">
                            <div class="orderImage">
                                <img :src="$img(item.goods_avatar)" alt="" />
                            </div>
                            <div class="orderGoodsName" v-text="item.goods_name"></div>
                            <div class="ordernum">
                                ×{{item.num}}
                            </div>
                        </div>
                        <div class="orderc2">
                            <div class="topor" v-text="`￥${item.goods_price}`"></div>
                            <div class="botor">
                                微信支付
                            </div>
                        </div>
                        <div class="orderc3">
                            <div class="topor" style="color: #666666;" v-text="`${item.order_status_text}`"></div>
                            <div class="botor cursor" @click="toDetail(item)">
                                订单详情 &gt;
                            </div>
                        </div>
                        <div class="orderc4">
                            <div class="btstyle11" @click="toDetail(item)" v-if="item.order_status == 10">
                                马上付款
                            </div>
                            <div class="btstyle11" v-if="item.order_status == 30" @click="receiveOrder(item)">
                                确认收货
                            </div>
                            <div class="btstyle2" @click="cancelOrder(item)" v-if="item.order_status == 10">
                                取消订单
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else style="box-sizing: border-box;padding-top: 100px;">
            <img :src="$Localimg('noorder.png')" class='nodatas' alt="" />
        </div>
    </div>
</template>

<script>
    import {
        getBookOrder,
        cencelbORder,
        confirmRecieve
    } from "@/api/index.js"
    export default {
        name: 'Order',
        data() {
            return {
                cur: "0",
                list: []
            }
        },
        created() {

        },
        mounted() {
            this.getList()
        },
        methods: {
            receiveOrder(e){
                let that = this
                let data = e.id
                that.$confirm('您确定收到货物了?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    confirmRecieve(data).then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {
                
                });
            },
            cancelOrder(e) {
                let that = this
                let data = {}
                data.order_id = e.id
                that.$confirm('确定要取消该订单吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cencelbORder(data).then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });

            },
            toDetail(e) {
                this.$router.push({
                    path: '/bookOrderDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            handleClick(e) {
                let that = this
                that.cur = e.name
                that.getList()
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 50
                data.order_status = that.cur
                getBookOrder(data).then((res) => {
                    if (res.code == 1) {
                        that.list = res.data.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .btstyle2 {
        font-size: 12px;
        color: #666666;
        line-height: 21px;
        margin-top: 6px;
        cursor: pointer;
    }

    .btstyle11 {
        width: 74px;
        height: 24px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #E4393C;
        color: #E4393C;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        cursor: pointer;
    }

    .topor {
        text-align: center;
        padding: 6px 0;
        border-bottom: 1px solid #D9D9D9;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
    }

    .botor {
        text-align: center;
        padding: 8px 0;
        font-size: 12px;
        color: #999999;
        line-height: 21px;
    }

    .ordernum {
        font-size: 14px;
        color: #999999;
        flex: 1;
        text-align: right;
    }

    .orderGoodsName {
        font-weight: 600;
        font-size: 14px;
        color: #666666;
        width: 240px;
        text-align: left;
    }

    .orderImage {
        width: 80px;
        height: 80px;
        margin-right: 10px;
        flex-shrink: 0;
    }

    .orderImage img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    .orderContent {
        background: #fff;
    }

    .orderItems {
        margin-top: 21px;
        height: 780px;
        overflow-y: auto;
    }

    .orderTit {
        height: 32px;
        background: #F2F2F2;
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
    }

    .orderItem {
        width: 99.8%;
        border: 1px solid #D9D9D9;
        margin-bottom: 20px;
    }

    .ordersContent {
        box-sizing: border-box;
        padding: 30px;
    }

    .orderTitles {
        height: 32px;
        background: #F2F2F2;
        width: 100%;

    }

    .orderc1 {
        width: 464px;
        height: 128px;
        box-sizing: border-box;
        padding: 24px;
        border-right: 1px solid #D9D9D9;
    }

    .orderc2 {
        width: 124px;
        height: 128px;
        border-right: 1px solid #D9D9D9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
    }

    .orderc3 {
        width: 157px;
        height: 128px;
        border-right: 1px solid #D9D9D9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
    }

    .orderc4 {
        width: 176px;
        height: 128px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .orderTitle1 {
        width: 464px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle2 {
        width: 126px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle3 {
        width: 157px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle4 {
        width: 176px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }
</style>